<template>
  <div class="row marketing">
    <div class="col-lg-6 offset-3">
      <h4 style="padding-bottom: 20px;">
        Login
      </h4>
      <div class="row" v-if="checkingLogin">
        <div class="col text-center">
          <svg width="100" height="30" viewBox="0 0 150 50"
               xmlns="http://www.w3.org/2000/svg" attr-fill="green">
            <circle cx="15" cy="15" r="15">
              <animate attributeName="r" from="15" to="15"
                       begin="0s" dur="0.8s"
                       values="15;9;15" calcMode="linear"
                       repeatCount="indefinite"/>
              <animate attributeName="fill-opacity" from="1" to="1"
                       begin="0s" dur="0.8s"
                       values="1;.5;1" calcMode="linear"
                       repeatCount="indefinite"/>
            </circle>
            <circle cx="60" cy="15" r="9" fill-opacity="0.3">
              <animate attributeName="r" from="9" to="9"
                       begin="0s" dur="0.8s"
                       values="9;15;9" calcMode="linear"
                       repeatCount="indefinite"/>
              <animate attributeName="fill-opacity" from="0.5" to="0.5"
                       begin="0s" dur="0.8s"
                       values=".5;1;.5" calcMode="linear"
                       repeatCount="indefinite"/>
            </circle>
            <circle cx="105" cy="15" r="15">
              <animate attributeName="r" from="15" to="15"
                       begin="0s" dur="0.8s"
                       values="15;9;15" calcMode="linear"
                       repeatCount="indefinite"/>
              <animate attributeName="fill-opacity" from="1" to="1"
                       begin="0s" dur="0.8s"
                       values="1;.5;1" calcMode="linear"
                       repeatCount="indefinite"/>
            </circle>
          </svg>
        </div>
      </div>
      <form action="" name="cform" v-on:submit="login()" v-if="!checkingLogin && !is3M()">
        <div class="form-group">
          <label for="exampleInputEmail0">User Name</label>
          <input type="text" class="form-control"
                 id="exampleInputEmail0" aria-describedby="emailHelp"
                 v-model="f.userName"
                 required
                 placeholder="Enter your UserName">

        </div>
        <div class="form-group">
          <label for="exampleInputEmail1">Password</label>
          <input type="password" class="form-control"
                 id="exampleInputEmail1" aria-describedby="emailHelp"
                 v-model="f.password"
                 required
                 placeholder="Enter your Password">

        </div>
        <div class="alert alert-danger" v-if="loginFailed && !is3M()">Login Failed</div>
        <div class="alert alert-danger" v-if="loginFailed && is3M()">Unable to Login, Contact Administrator</div>
        <button type="button" v-on:click="login()" class="btn btn-primary" v-if="!is3M()">
          Login
        </button>
        <button type="button" v-on:click="googleLogin()" class="btn btn-danger" v-if="!is3M()">
          <i class="fab fa-google-plus-g"></i> Login
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
let jwtDecode = require('jwt-decode')

export default {
  name: 'Login',
  data () {
    return {
      f: {
        userName: '',
        password: ''
      },
      r: {
        mobile: '',
        state: 'WAIT_MOBILE',
        otp: ''
      },
      loginFailed: false,
      checkingLogin: true
    }
  },
  created: function () {
    let $this = this
    this.$store.dispatch('isLoggedIn').then(() => {
      $this.handleLoggedIn()
    }, err => {
      console.error('error in login check', err)
      $this.handleLoggedIn()
    })
  },
  methods: {
    handleLoggedIn: function () {
      let $this = this
      if (this.$store.state.loggedIn) {
        this.fetchTenant()
      } else {
        // auth check
        if (this.is3M()) {
          console.log('3M, Doing Auth Check')
          axios.get('/auth/check').then(ok => {
            console.log('AuthCheck OK', ok.data)
            $this.handleLogin(ok.data)
          }, err => {
            this.checkingLogin = false
            this.loginFailed = true
            console.error('Nope User not found in authCheck', err)
          })
        } else {
          this.checkingLogin = false
          console.log(`ignore auth check... ${process.env.NODE_ENV} / ${window.location.hostname}`)
        }
      }
    },
    is3M: function () {
      return (window.location.hostname.indexOf('inpod.3m.com') > -1)
    },
    fetchTenant: function () {
      this.$router.push('/')
    },
    googleLogin: function () {
      this.loginFailed = false
      let $this = this
      this.$auth.authenticate('google').then(function (r) {
        let decoded = jwtDecode(r['data']['token'])
        console.log('logged in', r, decoded)
        $this.handleLogin({'authToken': decoded['sub']})
      }, err => {
        console.log('error in g+ login', err)
        this.loginFailed = true
      })
    },
    login: function () {
      this.loginFailed = false
      let $this = this
      axios.post(`/auth/login`, this.f).then(function (response) {
        $this.handleLogin(response.data)
      }, error => {
        console.log('Error in Login', error)
        this.loginFailed = true
      })
    },
    handleLogin: function (authToken) {
      if (authToken['authToken']) {
        this.$store.commit('loggedIn', authToken)
        this.fetchTenant()
      } else {
        console.log('Login Failed?', authToken)
        this.loginFailed = true
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue